const NAME = 'WOOPRA';
const CNameMapping = {
  [NAME]: NAME,
  Woopra: NAME,
  woopra: NAME,
};

export { NAME, CNameMapping };
